import { useEffect } from 'react'

// Sets document.title while the calling component is mounted, restoring the
// previous title on unmount so navigating away (or to a page that doesn't
// use this hook) doesn't leave a stale title behind.
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return
    const previousTitle = document.title
    document.title = `${title} · Lion's Den`
    return () => {
      document.title = previousTitle
    }
  }, [title])
}
